import React from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "./Header.css";

const Header = () => {
    const { user, logout, isAuthenticated } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate("/"); // 導向首頁
    };

    const handleNavigation = (path) => {
        navigate(path);
    };

    // 檢查用戶權限 - 支援多種數據結構
    const isModerator = user?.permissions?.can_moderate || user?.can_moderate || false;
    const isAdmin = user?.permissions?.can_administrate || user?.can_administrate || false;

    return (
        <header>
            <div className="header-content">
                <h1 className="logo" onClick={() => handleNavigation("/")}>
                    🌺 xxxmemo
                </h1>
                <nav className="main-nav">
                    <ul className="nav-list">
      
   
                        {/* 版主和管理員導航 */}
                        {isModerator && (
                            <li className="nav-item admin-nav">
                                <button 
                                    className="nav-btn moderate"
                                    onClick={() => handleNavigation("/system/moderate")}
                                >
                                     版主管理
                                </button>
                            </li>
                        )}
                        
                        {isAdmin && (
                            <>
                                <li className="nav-item admin-nav">
                                    <button 
                                        className="nav-btn admin"
                                        onClick={() => handleNavigation("/system/admin")}
                                    >
                                         系統管理
                                    </button>
                                </li>
                                <li className="nav-item admin-nav">
                                    <a 
                                        href="https://xxxmemo.com/admin/" 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="nav-btn django-admin"
                                    >
                                        🔧 Django Admin
                                    </a>
                                </li>
                            </>
                        )}

                        {/* 認證相關按鈕 */}
                        {isAuthenticated ? (
                            <>
                                <li className="nav-item user-info">
                                    <div className="welcome-message">
                                        <span className="welcome-text">{user.username}</span>
                                        {user?.role_display && (
                                            <span className="role-badge">{user.role_display}</span>
                                        )}
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <button 
                                        className="nav-btn logout"
                                        onClick={handleLogout}
                                    >
                                        🚪 登出
                                    </button>
                                </li>
                            </>
                        ) : (
                            <>
                                <li className="nav-item">
                                    <button 
                                        className="nav-btn secondary"
                                        onClick={() => handleNavigation("/login")}
                                    >
                                        🔑 登入
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button 
                                        className="nav-btn accent"
                                        onClick={() => handleNavigation("/register")}
                                    >
                                        ✨ 註冊
                                    </button>
                                </li>
                            </>
                        )}
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default React.memo(Header);